import React, { Component } from 'react';
import './style.scss';
import MdTagFaces from 'react-icons/lib/md/tag-faces';
import MdSecurity from 'react-icons/lib/md/security';
import MdFlag from 'react-icons/lib/md/flag';
import MdEqualizer from 'react-icons/lib/md/equalizer';
import { Col, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import Loader from '../../../../common/components/Loader/Loader';

class BannerPreview extends Component {
  render() {
    const {
      code,
      bannerText,
      whereToApply,
      bannerImage,
      bannerPhone,
      discountMessage,
      processing,
    } = this.props;

    const popoverClickRootClose = (
      <Popover
        id="popover-trigger-click-root-close"
        className="banner-popover"
        title="Where do I apply my code?"
      >
        <div className="banner-image-info">{whereToApply}</div>
      </Popover>
    );

    if (processing) {
      return (
        <div>
          <Loader />
          Processing Banner...
        </div>
      );
    }

    return (
      <div className="banner-container">
        <div className="content">
          <div className="elements">
            <div className="banner-logo">
              <img src={require('./img/logo-just-travel.png')} alt="just-travel" />
            </div>
            <div className="banner-tag">
              <img src={require('./img/tag.png')} alt="no age limit travel insurance" />
            </div>
            {bannerPhone && (
              <div className="banner-phone-number">
                UK CALL CENTRE <br />
                {bannerPhone}
              </div>
            )}
          </div>
          <div className="banner-text">{bannerText}</div>
          {code && (
            <div className="campaign-code">
              Code: <span>{code}</span>
            </div>
          )}
          <div className="banner-links">
            <ul>
              <li>No thanks</li>
              <OverlayTrigger
                trigger="click"
                rootClose
                placement="top"
                overlay={popoverClickRootClose}
              >
                <li>Where do I apply my code?</li>
              </OverlayTrigger>
            </ul>
          </div>
        </div>
        <div className="right-section">
          <div className="banner-image">
            <div className="banner-image-text">
              {discountMessage ? discountMessage : ''}
            </div>

            <img src={bannerImage && bannerImage.attributes.url} alt="jtc" />
          </div>
          <div className="banner-review">
            <img src={require('./img/reviews-row-update1.png')} alt="reviews" />
          </div>
          <div className="banner-footer">
            <Row>
              <Col xs={3} className="footer-border-box">
                <MdTagFaces />
                <p>Buy with confidence</p>
              </Col>
              <Col xs={3} className="footer-border-box-even">
                <MdSecurity />
                <p>SecurePayment</p>
              </Col>
              <Col xs={3} className="footer-border-box">
                <MdFlag />
                <p>UK call centre</p>
              </Col>
              <Col xs={3}>
                <MdEqualizer />
                <p>Leading broker</p>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

export default BannerPreview;
